import React from 'react';
import { RewardsAndOffersContext } from '../../../contexts';
import { PageSectionPB } from '../shared';
import { PrefPricingBanner, PrefPricingBlurbs } from './components';
export var getBenefitTags = function (rewardsAndOffers, tagName) {
    var _a, _b;
    var benefitTags = (_a = rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.proTiers) === null || _a === void 0 ? void 0 : _a.benefitTags;
    var benefit = benefitTags &&
        (benefitTags === null || benefitTags === void 0 ? void 0 : benefitTags.find(function (tag) {
            return tag.tagName === tagName;
        }));
    return { tag: benefit, value: (_b = benefit === null || benefit === void 0 ? void 0 : benefit.value) === null || _b === void 0 ? void 0 : _b.toLowerCase() };
};
export var PreferredPricing = function (props) {
    var _a;
    var isMobile = props.isMobile;
    var rewardsAndOffers = React.useContext(RewardsAndOffersContext).rewardsAndOffers;
    var isQualified = ((_a = getBenefitTags(rewardsAndOffers, 'PreferredPricing')) === null || _a === void 0 ? void 0 : _a.value) === 'unlocked';
    return (React.createElement(PageSectionPB, { title: "Pro Xtra Preferred Pricing", classes: "sui-pt-4 sui-mt-2", isMobile: isMobile },
        React.createElement(PrefPricingBanner, { isMobile: isMobile, isQualified: isQualified }),
        React.createElement(PrefPricingBlurbs, { isMobile: isMobile, isQualified: isQualified })));
};
